import { RootState } from '../../../app';

export const selectHasInternetConnection = ({ connectivity }: RootState) =>
  connectivity.hasInternetConnection;
